import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-purple-50/30 to-white flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="text-center"
        data-testid="landing-container"
      >
        <motion.img
          src="https://customer-assets.emergentagent.com/job_c19329c1-9bab-43aa-9723-765360d28c48/artifacts/deynhimw_indweller%20stay%20logo%20final.png"
          alt="INDWELLER STAY Logo"
          className="w-64 md:w-96 mx-auto mb-8"
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          data-testid="landing-logo"
        />

        <motion.h1
          className="font-heading text-2xl md:text-3xl font-medium text-gray-800 mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          data-testid="landing-tagline"
        >
          Comfortable & Affordable Living
        </motion.h1>

        <motion.button
          onClick={() => navigate('/home')}
          className="bg-brand-purple text-white px-12 py-4 rounded-full font-body text-lg font-medium hover:bg-opacity-90 transition-all shadow-lg shadow-purple-900/20 hover:shadow-xl hover:shadow-purple-900/30"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          data-testid="landing-enter-button"
        >
          Enter Website
        </motion.button>
      </motion.div>
    </div>
  );
};
